import { RouteConfig } from "vue-router";
import DentalTempComponent from "@/views/dental-temps/dental-temps.vue";
import { Roles } from "@/types/enums.type";

export default [
  {
    path: "/dental-temps",
    name: "DentalTemp",
    component: DentalTempComponent,
    meta: {
      roles: [Roles.PracticeUser, Roles.OfficeUser],
      nav: true,
      navTitle: "Dental Temps",
      navIcon: "fa-user-friends"
    }
  }
] as RouteConfig[];